import script from "./OccasionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OccasionsTable.vue?vue&type=script&setup=true&lang=js"

import "./OccasionsTable.vue?vue&type=style&index=0&id=c0e37cb8&lang=css"

const __exports__ = script;

export default __exports__